import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';
import { Moon, Sun } from 'lucide-react';

const BottomThemeToggle = () => {
  const { isDark, toggleTheme } = useTheme();

  return (
    <div 
      className="bottom-theme-toggle"
      style={{
        position: 'fixed',
        bottom: '20px',
        right: '20px',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '50px',
        height: '50px',
        borderRadius: '50%',
        background: 'var(--tertiary)',
        color: 'var(--primary)',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        border: '2px solid var(--border)',
        transform: 'scale(1)',
      }}
      onClick={toggleTheme}
      onMouseEnter={(e) => {
        e.target.style.transform = 'scale(1.1)';
        e.target.style.boxShadow = '0 6px 20px rgba(0, 0, 0, 0.25)';
      }}
      onMouseLeave={(e) => {
        e.target.style.transform = 'scale(1)';
        e.target.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.15)';
      }}
      aria-label={isDark ? '切换到亮色模式' : '切换到暗色模式'}
      title={isDark ? '切换到亮色模式' : '切换到暗色模式'}
    >
      {isDark ? (
        <Sun size={24} style={{ transition: 'transform 0.3s ease' }} />
      ) : (
        <Moon size={24} style={{ transition: 'transform 0.3s ease' }} />
      )}
    </div>
  );
};

export default BottomThemeToggle; 